import DealerError from './DealerError.js'

export class GetPaginationSearchUrlDealerError extends DealerError {}
